import APIClient from './index';
import _ from 'lodash';

// Axios puts the server error on err.response.data.error; the legacy `data.error` path misses it.
// Try both so the real message surfaces in the toast.
const getError = err => {
  const fromResponse = _.get(err, 'response.data.error');
  if (fromResponse) {
    if (typeof fromResponse === 'string') return fromResponse;
    return fromResponse.message || fromResponse.details?.[0]?.message || JSON.stringify(fromResponse);
  }
  return _.get(err, 'data.error') || err?.message;
};

/**
 * @returns {Promise<{ blocks: Array<{ id: number, countryCode: string, tier: string, notes: string|null, createdAt: string, updatedAt: string }> }>}
 */
export const getWaitlistBlockedCountries = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/WaitlistBlockedCountries')
      .then(response => resolve(response.data))
      .catch(err => reject(getError(err)));
  });
};

/**
 * @param {Object} data
 * @param {string} data.countryCode - ISO-3166-1 alpha-2 (e.g. 'HK')
 * @param {'hard_block'|'raised_threshold'} data.tier
 * @param {string} [data.notes]
 */
export const createWaitlistBlockedCountry = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('/WaitlistBlockedCountries', data)
      .then(response => resolve(response.data))
      .catch(err => reject(getError(err)));
  });
};

export const updateWaitlistBlockedCountry = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/WaitlistBlockedCountries/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(getError(err)));
  });
};

export const deleteWaitlistBlockedCountry = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`/WaitlistBlockedCountries/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(getError(err)));
  });
};

/**
 * @returns {Promise<{ countries: Array<{ code: string, name: string }> }>}
 */
export const getAvailableCountries = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/WaitlistBlockedCountries/available_countries')
      .then(response => resolve(response.data))
      .catch(err => reject(getError(err)));
  });
};
